import "./AmazonPage.css";

import React, { useState } from "react";

import AboutServiceTab from "./AboutServiceTab/AboutServiceTab";
import ProcessAndTimelineTab from "./ProcessAndTimelineTab/ProcessAndTimelineTab";
import ServiceCostTab from "./ServiceCostTab/ServiceCostTab";
// import ApplicationAndStatusTab from "./ApplicationAndStatusTab/ApplicationAndStatusTab";

import GetStartedHero from "../GetStarted/GetStartedHero";
import ProcessStepSelector from "../Shared/ProcessStepSelector/ProcessStepSelector";
import Footer from "../../Footer";

function AmazonPage() {
    const stepsData = [
        {
            label: "아마존 킨들 출판 대행 서비스란?",
            Component: AboutServiceTab
        },
        {
            label: "서비스 과정 및 일정",
            Component: ProcessAndTimelineTab,
        },
        {
            label: "비용",
            Component: ServiceCostTab,
        },
        // {
        //     label: "서비스 신청 및 조회",
        //     Component: ApplicationAndStatusTab,
        // }
    ];

    return (
        <div className="amazon-page">
            <GetStartedHero title={"아마존 킨들 출판 대행"} />
            <div className="amazon-page-tabs">
                <ProcessStepSelector stepsData={stepsData} />
            </div>
            <Footer />
        </div>
    );
}

export default AmazonPage;
